import { render, staticRenderFns } from "./ViewProfile.vue?vue&type=template&id=2a28254f&"
import script from "./ViewProfile.vue?vue&type=script&lang=js&"
export * from "./ViewProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports